import { z } from "zod";

const NewFolderSchema = z.object({
  name: z.string().trim().nonempty(),
  icon: z.string(),
  parent_id: z.string().nullable(),
});

export { NewFolderSchema };
